import { States } from '../ConnectForm/formSelectOptions';

const Credentials = {
    APRN: { label: "APRN", requiresNPI: false },
    CNM: { label: "CNM", requiresNPI: true },
    CRNA: { label: "CRNA", requiresNPI: false },
    DDS: { label: "DDS", requiresNPI: false },
    DMD: { label: "DMD", requiresNPI: false },
    DNP: { label: "DNP", requiresNPI: false },
    DO: { label: "DO", requiresNPI: false },
    DPM: { label: "DPM", requiresNPI: false },
    LPN: { label: "LPN", requiresNPI: false },
    MD: { label: "MD", requiresNPI: false },
    NP: { label: "NP", requiresNPI: false },
    OLHCP: { label: "Other Licensed HCP", requiresNPI: true },
    RN: { label: "RN", requiresNPI: true },
    RNBC: { label: "RN-BC", requiresNPI: true },
    RNC: { label: "RN-C", requiresNPI: true },
    RPH: { label: "RPH", requiresNPI: true }
};

const Specialties = {
    Anesthesiology: "Anesthesiology",
    // BariatricSurgery: "Bariatric Surgery",
    BreastSurgery: "Breast Surgery",
    CardiacSurgery: "Cardiac Surgery",
    ColorectalSurgery: "Colorectal Surgery",
    ENT: "ENT",
    GeneralSurgery: "General Surgery",
    ObstetricsSurgery: "Obstetrics/Gynecologic Surgery/Urogynecologist",
    Nursing: "Nursing",
    OralSurgery: "Oral Surgery",
    OrthopedicSurgery: "Orthopedic Surgery",
    PainManagement: "Pain Management",
    PlasticSurgery: "Plastic Surgery",
    SpineNeurosurgery: "Spine/Neurosurgery",
    ThoracicSurgery: "Thoracic Surgery",
    UrologyNephrology: "Urology/Nephrology",
    Other: "Other",
};

const AgeOfPatients = [
    { value: 'pediatrics', label: 'Pediatrics' },
    { value: 'adolescents_adults', label: 'Adolescents & Adults' },
    { value: 'adults', label: 'Adults' }
];

const Procedures = [
    {
        value: 'bariatric',
        label: 'Bariatric',
        procedures: [
            { value: 'roux_en_y_gastric_bypass', label: 'Roux-En-Y Gastric Bypass' },
            { value: 'laparoscopic_sleeve_gastrectomy', label: 'Laparoscopic Sleeve Gastrectomy' }
        ],
        specialties: ['Anesthesiology', 'Pain Management']
    },
    {
        value: 'breast',
        label: 'Breast',
        procedures: [
            { value: 'mastectomy', label: 'Mastectomy' },
            { value: 'breast_augmentation', label: 'Breast Augmentation' },
            { value: 'breast_reconstruction', label: 'Breast Reconstruction' },
            { value: 'breast_reduction', label: 'Breast Reduction' },
            { value: 'lumpectomy', label: 'Lumpectomy' }
        ],
        specialties: ['Anesthesiology', 'Breast Surgery', 'Pain Management']
    },
    {
        value: 'cardiac',
        label: 'Cardiac',
        procedures: [
            { value: 'cardiothoracic', label: 'Cardiothoracic' }
        ],
        specialties: ['Anesthesiology', 'Cardiac Surgery', 'Pain Management']
    },
    {
        value: 'colorectal_general',
        label: 'Colorectal/General',
        procedures: [
            { value: 'appendectomy', label: 'Appendectomy' },
            { value: 'cholecystectomy', label: 'Cholecystectomy' },
            { value: 'colectomy', label: 'Colectomy' },
            { value: 'hernia', label: 'Hernia' },
            { value: 'hemorrhoidectomy', label: 'Hemorrhoidectomy' },
            { value: 'laparoscopic_hemicolectomy', label: 'Laparoscopic Hemicolectomy' },
            { value: 'small_bowel_resection', label: 'Small Bowel Resection' }
        ],
        specialties: ['Anesthesiology', 'Colorectal Surgery', 'General Surgery', 'Pain Management']
    },
    {
        value: 'ent',
        label: 'ENT',
        procedures: [
            { value: 'tonsillectomy', label: 'Tonsillectomy' }
        ],
        specialties: ['Anesthesiology', 'ENT', 'Pain Management']
    },
    {
        value: 'obstetric_gynecologic',
        label: 'Obstetric/Gynecologic',
        procedures: [
            { value: 'laparoscopic_hysterectomy', label: 'Laparoscopic Hysterectomy' },
            { value: 'open_hysterectomy', label: 'Open Hysterectomy' },
            { value: 'open_myoectomy', label: 'Open Myoectomy' }
        ],
        specialties: ['Anesthesiology', 'Obstetrics/Gynecologic Surgery/Urogynecologist', 'Pain Management']
    },
    {
        value: 'orthopedic',
        label: 'Orthopedic',
        procedures: [
            { value: 'bunionectomy', label: 'Bunionectomy' },
            { value: 'foot_and_ankle', label: 'Foot and Ankle' },
            { value: 'hand', label: 'Hand' },
            { value: 'hip_arthroplasty', label: 'Hip Arthroplasty' },
            { value: 'lumbar_laminectomy', label: 'Lumbar Laminectomy' },
            { value: 'meniscus', label: 'Meniscus' },
            { value: 'mis_transforaminal_lumbar_interbody_fusion', label: 'MIS Transforaminal Lumbar Interbody Fusion' },
            { value: 'rotator_cuff_repair', label: 'Rotator Cuff Repair' },
            { value: 'total_hip_arthroplasty', label: 'Total Hip Arthroplasty' },
            { value: 'total_knee_arthroplasty', label: 'Total Knee Arthroplasty' },
            { value: 'total_shoulder_arthroplasty', label: 'Total Shoulder Arthroplasty' },
            { value: 'other_sports_procedures', label: 'Other Sports Procedures' }
        ],
        specialties: ['Anesthesiology', 'Orthopedic Surgery', 'Pain Management']
    },
    {
        value: 'plastics',
        label: 'Plastics',
        procedures: [
            { value: 'breast_augmentation', label: 'Breast Augmentation' },
            { value: 'breast_reconstruction', label: 'Breast Reconstruction' },
            { value: 'breast_reduction', label: 'Breast Reduction' },
            { value: 'facial_surgery', label: 'Facial Surgery' },
            { value: 'liposuction', label: 'Liposuction' },
            { value: 'skin_removal_body_contouring', label: 'Skin Removal/Body Contouring' }
        ],
        specialties: ['Anesthesiology', 'Plastic Surgery', 'Pain Management']
    },
    {
        value: 'spine_neurosurgery',
        label: 'Spine/Neurosurgery',
        procedures: [
            { value: 'laminectomy', label: 'Laminectomy' },
            { value: 'fusion', label: 'Fusion' },
            { value: 'pediatric_scoliosis', label: 'Pediatric Scoliosis' }
        ],
        specialties: ['Anesthesiology', 'Spine/Neurosurgery', 'Pain Management']
    },
    {
        value: 'thoracic',
        label: 'Thoracic',
        procedures: [
            { value: 'nuss_bar', label: 'Nuss Bar' }
        ],
        specialties: ['Anesthesiology', 'Thoracic Surgery', 'Pain Management']
    },
    {
        value: 'urologic',
        label: 'Urologic',
        procedures: [
            { value: 'nephrectomy_kidney', label: 'Nephrectomy/Kidney' }
        ],
        specialties: ['Anesthesiology', 'Urology/Nephrology', 'Pain Management']
    },
    {
        value: 'oral_maxillofacial',
        label: 'Oral/Maxillofacial',
        procedures: [
            { value: 'full_maxillary_reconstruction', label: 'Full Maxillary Reconstruction' },
            { value: 'maxillofacial_trauma', label: 'Maxillofacial Trauma' },
            { value: 'orthognathic', label: 'Orthognathic' },
            { value: 'temporomandibular_joint', label: 'Temporomandibular Joint' },
            { value: 'third_molar_wisdom_teeth_extraction', label: 'Third Molar/Wisdom Teeth Extraction' }
        ],
        specialties: ['Oral Surgery', 'Pain Management']
    },
    { value: 'other', label: 'Other' }
];

const getProceduresBySpecialty = (selectedSpecialties) => {

    if (!selectedSpecialties || selectedSpecialties.length === 0) {
        return [];
    }

    // Get all procedures that match any of the selected specialties
    const filteredProcedures = Procedures.filter(procedure =>
        procedure.specialties && selectedSpecialties.some(specialty =>
            procedure.specialties.includes(Specialties[specialty] || specialty)
        )
    ).map(procedure => ({
        value: procedure.value,
        label: procedure.label,
        type: 'group',
        options: procedure.procedures.map(subProcedure => ({
            value: subProcedure.value,
            label: subProcedure.label,
            type: 'option'
        }))
    }));

    return filteredProcedures;
};

export { States, Credentials, Specialties, AgeOfPatients, Procedures, getProceduresBySpecialty }; 